import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ElciValidators {

  static notEqualToZero(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value !== '0') {
      return null; // It's valid
    } else {
      return { notEqualToZero: true }; // It's invalid
    }
  }

  static emailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === ""){
      return null;
    }else{
      const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
      return !isValidEmail ? { 'invalidEmail': true } : null;
    }
  }

  static nameValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === ""){
      return null;
    }else{      
      const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ ]+$/;
      return nameRegex.test(value) ? null : { invalidName: true };
    }
  }
  static documentValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === ""){
      return null;
    }else{      
      const documentRegex = /^[a-zA-Z0-9]+$/;
      return documentRegex.test(value) ? null : { invalidDocument: true };
    }
  }
  static postcodeValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === ""){
      return null;
    }else{      
      const postcodeRegex = /^\d{5,6}$/;
      return postcodeRegex.test(value) ? null : { invalidPostcode: true };
    }
  }

  static numcolValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === ""){
      return null;
    }else{      
      const numcolRegex = /^\d{5,9}$/;
      return numcolRegex.test(value) ? null : { invalidNumcol: true };
    }
  }

  static phoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === ""){
      return null;
    }else{      
      const phoneRegex = /^\d{9,15}$/;
      return phoneRegex.test(value) ? null : { invalidPhone: true };
    }
  }

  static addressValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === "") return null;

    const addressRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 !@#$%^&*()_+\-=[\]{};:'",.<>/?`~|\\]+$/;
    return addressRegex.test(value) ? null : { invalidAddress: true };
  }

  static passwordValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || value === "") return null;

    const passwordRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};:'",.<>/?`~|\\]+$/;
    if (!passwordRegex.test(value)) {
      return { invalidPassword: true };
    }  
    // Validación de longitud mínima
    if (value.length < 8) {
      return { minLengthPassword: true };
    }  
    return null;
  }
  // para comparar que las pass son iguales
  static passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const repeatPass = group.get('repeatPass')?.value;  
    return password === repeatPass ? null : { passwordsNotMatching: true };
  }

  static trueOrFalseInteger(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value !== 0 || value !== 1) {
      return null; // It's valid
    } else {
      return { trueOrFalseInteger: true }; // It's invalid
    }
  }

  static noPastDate(control: AbstractControl): ValidationErrors | null {
    const inputDate = new Date(control.value);
    const today = new Date();
    inputDate.setUTCHours(0, 0, 0, 0);
    today.setUTCHours(0, 0, 0, 0);    
    if (inputDate < today) {
      return { noPastDate: true };
    }
    return null;
  }

}

export const validNumbersValidator = (validValues: number[]) => {
  return (control: AbstractControl) => {
    const value = control.value;
    if (!validValues.includes(value)) {
      return { validNumbersValidator: true }; // It's invalid
    } else {
      return null; // It's valid
    }
  }

 
}